<template>

    <div class="bg-white shadow my-5">
        <ul class="nav nav-tabs nav-tabs-product" role="tablist">
            <li class="nav-item">
                <a class="nav-link active" id="product-calculator-tab" data-toggle="tab" href="#price-calculator"
                   role="tab" aria-controls="product-calculator" aria-selected="true">{{ dictionary.title}}</a>
            </li>
         
            <li class="nav-item">
                <a class="nav-link" id="mass-calculator-tab" data-toggle="tab" href="#mass-calculator" role="tab"
                   aria-controls="mass-calculator" aria-selected="false">{{ dictionary.massCalculator }}</a>
            </li>
        </ul>

        <div class="tab-content p-4">
            <div class="tab-pane fade show active" id="price-calculator" role="tabpanel"
                 aria-labelledby="price-calculator-tab">
                <div class="p-4" v-if="quantityMode">
                    <quantity-field-collection :variants="products"></quantity-field-collection>

                    <h6 class="mt-4 mb-0 font-weight-normal">
                        {{ dictionary.explainer }}
                        <a id="go-to-mass-calculator" data-toggle="tab" href="#mass-calculator" role="tab"
                   aria-controls="mass-calculator" aria-selected="false">
                            <strong>{{ dictionary.massCalculator }}</strong>
                        </a>
                    </h6>
                </div>
            </div>
          
            <div class="tab-pane fade" id="mass-calculator" role="tabpanel" aria-labelledby="mass-calculator-tab">
                <mass-calculator :variants="products"></mass-calculator>
            </div>
           
        </div>
    </div>







</template>

<script>
import MassCalculator from "./mass-calculator";
import QuantityFieldCollection from "./quantity-field-collection.vue";
import { GetTranslations } from "../services/translation.service";

export default {
  name: "PriceCalculator",
  props: {
    products: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      quantityMode: true,
      dictionary: GetTranslations("massCalculator"),
    };
  },
  components: {
    MassCalculator,
    QuantityFieldCollection,
  },
};
</script>